<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Check Missing Codes</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="4">
                        <v-file-input name="productExcelFile" v-model="excelFile" label="Browse Excel Sheet" outlined
                            dense></v-file-input>
                    </v-col>

                    <v-col cols="12">
                        <v-btn color="primary" @click="uploadExcel" :loading="$store.state.btnLoader">
                            <v-icon left>mdi-upload</v-icon> Check Missing Codes
                        </v-btn>
                    </v-col>

                    <v-col cols="12">
                        <!-- excel icon -->
                        <download-excel :data="missingCodesData" :fields="fields" name="Missing Products List">
                            <v-icon color="green">mdi-file-excel</v-icon>
                        </download-excel>
                        <!-- end -->
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <!-- start of table -->
                        <v-data-table :loading="loader" :mobile-breakpoint="0" loading-text="Loading Products........"
                            :items-per-page="1000" :headers="headers" :items="missingCodesData" :search="search">
                        </v-data-table>
                        <!-- end -->
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
    </v-container>
</template>

<script>
export default {
    components: {},
    data: () => ({
        search: "",
        searchCustomers: null,
        selectedCustomer: {},
        customers: [],
        queryStore: null,
        stores: [],
        loader: false,
        excelFile: null,
        date: null,
        missingCodesData: [],
        headers: [
            { text: "Item Code", value: "itemCode" },
            { text: "Product Name", value: "name" },
            { text: "Price", value: "price" },
            { text: "Category", value: "category" },
            { text: "Barcode", value: "barcode" },
        ],
        fields: {
            ItemCode: "itemCode",
            Product: "name",
            price: "price",
            category: "category",
            barcode: "barcode"
        },
    }),
    watch: {
        searchCustomers(val) {
            if (val && val !== this.select && this.queryCustomers(val)) {
                this.queryCustomers(val);
            }
        }
    },
    methods: {
        setDate(myDate) {
            this.date = myDate;
        },
        uploadExcel() {
            var store_id = this.queryStore;
            var subscriber_id = localStorage.getItem("subscriber_id");
            const data = new FormData();
            data.append("documentData", this.excelFile);
            data.append("store_id", parseInt(store_id));
            data.append("subscriber_id", parseInt(subscriber_id));
            this.$store.commit("btnLoader", true);
            const url = "/check-missing-codes";
            const self = this;
            this.$store
                .dispatch("post", { url, data })
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.missingCodesData = res.ResponseData;
                        self.$refs.snackbar.show(
                            "Checks successful",
                            "green"
                        );
                        self.$store.commit("btnLoader", false);
                        self.excelFile = null;
                    } else {
                        self.$store.commit("btnLoader", false);
                        self.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                })
                .catch((err) => {
                    self.$store.commit("btnLoader", false);
                    this.$refs.snackbar.show(err, "red");
                });
            // end
        },
    },
    created() {

    },
};
</script>